import { moduleProviderFactory } from "core/providers";
import { FacilityOrderNewFlowUSIntakeSinglePagePreview } from "application/facility-order-new-flow-us-intake-single-page/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.us-intake-single-page-preview",
						pattern: "/:id/new-flow/us-intake-old-single-page",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowUSIntakeSinglePagePreview,
						data: {
							//title: "",
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.US_INTAKE",
									route: 'master.app.main.facility-order.facility-order-new-flow.us-intake-single-page-preview'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},
					}
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
